import React, { useState, useEffect } from "react";
import "./forgetpassword.scss";
import { useNavigate, useLocation } from "react-router-dom";
import { useParams } from "react-router-dom";
import { Image_Url } from "../../constants/imageUrl/ImageUrl";
import { forgotPasswordAction } from "../../actions/passwordAction";
import { allLanguageListAction } from "../../actions/loginAction";
import { NotificationManager } from "react-notifications";
import { fetchAndActivate, getValue, remoteConfig } from "../../configuration";
import { useDispatch } from "react-redux";
import { HTTP_STATUS } from "../../constants/httpstatus/HttpsStatus";
import { useTranslation } from "react-i18next";
import Cookies from "js-cookie";

const ForgetPasswordForm = () => {
  const [email, setEmail] = useState("");
  const [error, setError] = useState("");
  const [selectedCountry, setSelectedCountry] = useState('');
  const [state, setDataState] = useState('');
  const [countryData, setCountryData] = useState([]);
  const [languagelist, setLanguageList] = useState([]);
  const [isSubmitting, setIsSubmitting] = useState(false)
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const location = useLocation();
  const { i18n, t } = useTranslation();
  const { countryCode, countryRegion } = useParams();
  const RouteEndPoint = process.env.REACT_APP_ROUTE_ENDPOINT || "";

  useEffect(() => {
    const fetchConfig = async () => {
      try {
        await fetchAndActivate(remoteConfig);

        const configString = getValue(remoteConfig, process.env.REACT_APP_FIREBASE_DEV_KEY).asString();
        const parseConfig = JSON.parse(configString);
        setCountryData(parseConfig);

        const country = parseConfig.find(
          item => item?.country_code === countryCode && item?.region === countryRegion
        );
        if (country) {
          setSelectedCountry(country?.country_code);
          localStorage.setItem('countryName', country?.country);
          localStorage.setItem('countryBackendUrl', country?.backend_url);
        } else {
          localStorage.clear('countryName');
        }
      } catch (error) {
        NotificationManager.error(error.message || 'There is an error in firebase');
      }
    };

    fetchConfig();
  }, [countryCode]);

  useEffect(() => {
    if (selectedCountry !== '') {
      getlanguagelist();
      handleChangeLanguage('en');
    }
  }, [selectedCountry]);

  const handleCountryChange = (event) => {
    event.preventDefault();
    const countryCode = event.target.value;
    const country = countryData?.find(item => item?.country_code === countryCode);

    if (country) {
      const countryRegion = country?.region;
      localStorage.setItem('countryName', country?.country);
      localStorage.setItem('countryBackendUrl', country?.backend_url);
      setSelectedCountry(country?.country_code);

      const formattedRouteEndpoint = RouteEndPoint.replace(/\/+$/, "");
      const newUrl = `${formattedRouteEndpoint}/${countryRegion}/${countryCode}`;
      window.history.replaceState({}, '', newUrl);
    }
  };

  const handleChange = (evt) => {
    const { name, value } = evt.target;
    setDataState({
      ...state,
      [evt.target.name]: value.replace(/^ +/gm, ""),
    });
    if (name === "language") {
      const selectedOption = evt.target.options[evt.target.selectedIndex];
      const dataLangValue = selectedOption.getAttribute("data-lang");
      const dataLangCode = selectedOption.getAttribute("data-lang-code")
      handleChangeLanguage(
        dataLangValue.toLowerCase() === "spanish" ? "es" :
          dataLangValue.toLowerCase() === "english" ? "en" :
            dataLangValue.toLowerCase() === "bangla" ? "bn" :
              dataLangValue.toLowerCase() === "swahili" ? "sw" :
                "en",
        dataLangCode
      );
    }
  };

  async function getlanguagelist() {
    let response = await dispatch(allLanguageListAction());
    if (response == 200 || response != null) {
      setLanguageList(response.data.data);
      const englishLanguage = response.data.data?.find(
        (item) => item?.language?.toLowerCase() === "english"
      );
      setDataState({
        ...state,
        language: englishLanguage?.id,
      });
      handleChangeLanguage("en", englishLanguage?.language_code);
    }
  }

  const handleChangeLanguage = (language, languageCode) => {
    Cookies.set("language", language, {
      expires: 1,
    });
    Cookies.set("languageCode", languageCode, {
      expires: 1,
    });
    i18n.changeLanguage(language);
  };

  const handleInputChange = (e) => {
    setEmail(e.target.value);
  };

  const handleSubmit = async(e) => {
    e.preventDefault();
    if (!email) {
      setError(t('forgetpassword.errormsg'));
      return false;
    }
    setError('');
    setIsSubmitting(true)
    let apiReq = {
      email: email,
      language_id: state.language
    };
    let response = await dispatch(forgotPasswordAction(apiReq));

    if (response?.status === HTTP_STATUS.SUCCESS ) {
      NotificationManager.success(response?.data?.message);
      navigate('/passwordconfirmation', { state: { key: 'forget_password' } });
      window.scroll(0, 0);
    }
    setIsSubmitting(false);
  };

  useEffect(() => {
    localStorage.clear();
    return () => {
      localStorage.clear();
    };
  }, []);

  useEffect(() => {
    const handleRefresh = () => {
      localStorage.clear();
    };
  
    window.addEventListener("beforeunload", handleRefresh);
  
    return () => {
      window.removeEventListener("beforeunload", handleRefresh);
    };
  }, []);

  return (
    <div className="forget-container">
      <div className="tvs-logo">
        <img height='80px' width='294px' src={Image_Url.TVSLOGO} alt="" />
      </div>
      <div className="reset-text">{t('forgetpassword.resetyourpass')}</div>
      <div className="forget-password-container">
        <p>
          {t('forgetpassword.enteremailtext')}
        </p>
        <div>
          <div className="select-input-wrapper">
            <label className="country-label" htmlFor="country">
              {t("login.selectCountry")}
            </label>
            <select value={selectedCountry} onChange={handleCountryChange} className="login-select">
              <option value="" disabled>Select a country</option>
              {countryData && countryData?.length > 0 ? (
                countryData?.map((country, index) => (
                  <option key={index} value={country?.country_code}>
                    {country?.country}
                  </option>
                ))
              ) : (
                <option disabled>No countries available</option>
              )}
            </select>
          </div>
          <div className="select-input-wrapper">
            <label className="language-label" htmlFor="language">
              {t("login.selectLanguage")}
            </label>
            <select
              className="login-select"
              id="language"
              name="language"
              value={state.language}
              onChange={handleChange}
            >
              <option value="" data-lang="">{t("login.selectLanguage")}</option>
              {languagelist?.map((item, index) => (
                <option
                  value={item.id}
                  data-lang={item.language}
                  data-lang-code={item.language_code}
                  key={index}
                >
                  {item.language}
                </option>
              ))}
            </select>
          </div>
          <div className="select-input-wrapper">
            <label className="language-label" htmlFor="language">
              {t("common.emailPlaceholder")}
            </label>
            <div>
              <input type="email" value={email} onChange={handleInputChange} placeholder={t('forgetpassword.entermail')} />
              {error && <div className="error-message">{error}</div>}
            </div>
          </div>
        </div>
        <button
          className="submit_btn"
          type="submit"
          onClick={handleSubmit}
          disabled={isSubmitting || !email || !state.language}
        >
          {t('forgetpassword.sendpassmail')}
        </button>
        {/* </form> */}
      </div>
    </div>
  );
};

export default ForgetPasswordForm;
